import { render } from "./vc4a-nav-bar-closable.vue?vue&type=template&id=1d842ef9"
import script from "./vc4a-nav-bar-closable.vue?vue&type=script&lang=js"
export * from "./vc4a-nav-bar-closable.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vc4a/vc4a/wp-content/themes/vc4africa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__